import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../../components/admin/Header";
import Sidebar from "../../components/admin/Sidebar";
import "./AdminLayout.css";

function AdminLayout() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="admin-layout">

      <Sidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />

      <div className="main-area">
        <Header toggleSidebar={toggleSidebar} />

        <div className="main-content">
          <Outlet />
        </div>
      </div>

    </div>
  );
}

export default AdminLayout;